/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import { Autocomplete, FormControl, MenuItem, TextField } from '@mui/material';
import { GarmentType } from '@services';
import { allGarmentTypes } from '../../../products/product-utilities';

interface GarmentTypeFilterComponentProps {
    value: string,
    onBlur: () => void,
    onChange: (event: React.ChangeEvent<HTMLInputElement> | { target: { name: string, value: any } }) => void,
    multiple?: boolean,
}

const GarmentTypeFilterComponent: FC<GarmentTypeFilterComponentProps> = (props) => {
    const { value, onBlur, onChange, multiple } = props;

    return (
        <div>
            {multiple ? (
                <FormControl fullWidth>
                    <Autocomplete
                        multiple
                        disableClearable
                        disableListWrap
                        size="small"
                        limitTags={2}
                        getOptionLabel={(o) => o}
                        value={value ? value.split(',') : []}
                        onChange={(event: any, newValue: string[] | null) => onChange({
                            target: {
                                name: 'garmentTypes',
                                value: newValue?.join(',') ?? '',
                            },
                        })}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Garment Types"
                                variant="outlined"
                                multiline={false}
                            />
                        )}
                        options={Object.keys(allGarmentTypes)}
                    />
                </FormControl>
            ) : (
                <TextField
                    data-testid="GarmentTypeFilterComponent"
                    fullWidth
                    key="garmentType"
                    onBlur={onBlur}
                    label="Garment type"
                    name="garmentType"
                    onChange={onChange}
                    value={value}
                    select
                >
                    <MenuItem key="" value=""><em>None</em></MenuItem>
                    {Object.keys(allGarmentTypes).map((k) => (
                        <MenuItem key={k} value={k}>{allGarmentTypes[k as GarmentType]}</MenuItem>
                    ))}
                </TextField>
            )}
        </div>
    );
};

export default GarmentTypeFilterComponent;

GarmentTypeFilterComponent.defaultProps = {
    multiple: false,
};
